import { render, staticRenderFns } from "./FormularioProntoComponent.vue?vue&type=template&id=7a1c3b5f&"
import script from "./FormularioProntoComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioProntoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioProntoComponent.vue?vue&type=style&index=0&id=7a1c3b5f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports